import {catchError} from 'rxjs/operators';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {AuthService} from './auth.service';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {
  constructor(private authService: AuthService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.getKapoSessionId();
    if (token) {
      let headers = new HttpHeaders();
      headers = headers.set('kapo_session_id', '' + token);
      const cloned = request.clone({ headers });
      return next.handle(cloned);
    } else {
      return next.handle(request);
    }
  }
}
